import { createContext } from 'react';

import type { BillingPlanData } from '@shared/dream-components';

/**
 * Logic layer for the admin / group billing fan-out on the Billing tab — the per-group
 * `AdminBillingElement` plans. Self-calls `useAdminBilling` and exposes the plans + loading
 * state via context. Holds no UI; the colocated `AdminBillingSection` child renders from it.
 * The subscriber's own billing (invoices / payment method) is a separate domain
 * (`BillingProvider`) and stays out.
 */
export type AdminBillingContextType = {
  adminBillingPlans: BillingPlanData[];
  isLoadingAdminBilling: boolean;
};

export const AdminBillingContext = createContext<AdminBillingContextType | undefined>(undefined);
AdminBillingContext.displayName = 'AdminBillingContext';
